import { usePermissions } from '@/features/auth';
import { canAddNote } from '../utils/timelineEntryLabels';
import { isListPanelFocusable } from '../utils/listPanelFocus';
import { useAgreementNotes } from './useAgreementNotes';

/** Notes are fetched only while the tab is open, and only for callers who may browse them. */
export function useAgreementNotesTab(id: string | undefined, isActive: boolean, status: string | undefined) {
    const { hasPermission } = usePermissions();
    const canBrowse = hasPermission({ resource: 'agreement', action: 'note.browse' });
    const hasFocusableAction =
        status !== undefined && canAddNote(status) && hasPermission({ resource: 'agreement', action: 'note.add' });
    const notes = useAgreementNotes(id, isActive && canBrowse);

    return {
        canBrowse,
        notes,
        focusablePanel: isListPanelFocusable({
            isLoading: notes.query.isLoading,
            isError: notes.query.isError,
            hasFocusableAction,
            lastPage: notes.query.data?.meta.lastPage,
        }),
    };
}
